import axios from "axios";
import { apiRequest } from "../utility/Utility";

export const logoutUser = async (emailId) => {
    try {
        await apiRequest({
            endpoint: "/api/signOut",
            payload: {
                email: emailId,
            },
            returnRaw: true
        });
        return {
            status: 0,
            title: "Signout successfully",
            message: "Success",
        };
    } catch (error) {
        //console.error("Exception occured while logging out user: ", error.message);
        return {
            status: 1,
            title: "Exception occured",
            message: "Exception occured while logging out user: " + error.message,
        };
    }
};
